import qs from 'qs';

import { client } from '../client';
import { Meta } from '../communication/types/Meta';

export type AuditUserRole = {
  id: number;
  name: string;
};

export type AuditUser = {
  id: number;
  full_name?: string;
  email?: string;
  role?: AuditUserRole;
};

export type AuditTrailCase = {
  id: number;
  patient: AuditUser;
};

export type AuditEvent = {
  id: number;
  action_message: string;
  message?: string;
  created_at: string;
  case?: AuditTrailCase;
  actor?: AuditUser;
  user?: AuditUser;
  case_id?: number;
};

export type ListAuditTrailResponse = {
  nodes: AuditEvent[];
  total: number;
  meta: Meta;
};

export type ListAuditTrailParams = {
  user_role?: string;
  user_name?: string;
  actor_name?: string;
  action_message?: string;
  search?: string;
  date_from?: string;
  date_to?: string;
  limit?: number;
  cursor?: string;
  cursor_direction?: 'next' | 'previous';
  sort_by?: 'created_at' | 'user_name' | 'actor_name' | 'action';
  sort_direction?: 'asc' | 'desc';
};

export const listAuditTrails = async (params?: ListAuditTrailParams | string): Promise<ListAuditTrailResponse> => {
  let queryString = '';
  if (params && typeof params === 'object') {
    queryString = `?${qs.stringify(params, { skipNulls: true })}`;
  } else if (typeof params === 'string') {
    queryString = `?${params}`;
  }

  const { data } = await client.get(`/admin/audit_trails${queryString}`);
  return data;
};
